import React from 'react';
import styled from 'styled-components';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import KeyFeatures from './components/KeyFeatures';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import GlobalStyle from './components/GlobalStyle';

function App() {
  return (
    <AppContainer>
      <GlobalStyle />
      <HeroSection />
      <HowItWorks />
      <KeyFeatures />
      <FAQ />
      <FinalCTA />
    </AppContainer>
  );
}

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: var(--color-background);
`;

export default App;
